module.exports = {
    "06cb77d8de": {
        "idVoucher": "06cb77d8de",
        "idPrimary": 40351,
        "dateCreated": "2020-08-07T21:40:34-05:00",
        "dateModified": "2022-03-16T02:27:27-05:00",
        "idProgram": "MAIN",
        "idAccount": "24f2e40c",
        "idUser": "590a03edb4",
        "type": "balance",
        "total": "5.00",
        "name": "Corporate Voucher Corporate Voucher Corporate Voucher Corporate Voucher ",
        "description": "Corporate Voucher",
        "dateExpiration": "-0001-11-30T00:00:00-06:00",
    },
    "1dd6e30c34": {
        "idVoucher": "1dd6e30c34",
        "idPrimary": 41493,
        "dateCreated": "2020-12-04T22:02:25-06:00",
        "dateModified": "2021-12-10T22:02:20-06:00",
        "idProgram": "7b61c906",
        "idAccount": "24f2e40c",
        "idUser": "590a03edb4",
        "type": "balance",
        "total": "11.75",
        "name": "Corporate Voucher",
        "description": "Corporate Voucher",
        "dateExpiration": "-0001-11-30T00:00:00-06:00",
        "usage": [
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 10774171,
                "dateCreated": "2020-12-04T22:08:05-06:00",
                "used": "94.72",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 10774171,
                "dateCreated": "2020-12-04T22:08:05-06:00",
                "used": "-89.72",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 10969482,
                "dateCreated": "2021-04-04T20:53:55-05:00",
                "used": "43.53",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 10969482,
                "dateCreated": "2021-04-04T20:53:55-05:00",
                "used": "-36.53",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11762910,
                "dateCreated": "2021-08-27T22:12:28-05:00",
                "used": "3.80",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11762910,
                "dateCreated": "2021-08-27T22:12:28-05:00",
                "used": "-3.80",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11838007,
                "dateCreated": "2021-09-17T23:02:05-05:00",
                "used": "6.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11838009,
                "dateCreated": "2021-09-17T23:02:05-05:00",
                "used": "5.25",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11838009,
                "dateCreated": "2021-09-17T23:02:05-05:00",
                "used": "-5.25",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11838007,
                "dateCreated": "2021-09-17T23:02:05-05:00",
                "used": "-6.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11842718,
                "dateCreated": "2021-10-01T13:53:19-05:00",
                "used": "6.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11842718,
                "dateCreated": "2021-10-01T13:53:19-05:00",
                "used": "-6.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11954995,
                "dateCreated": "2021-12-10T21:49:21-06:00",
                "used": "2.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11954995,
                "dateCreated": "2021-12-10T21:49:21-06:00",
                "used": "-2.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11930801,
                "dateCreated": "2021-12-10T21:52:12-06:00",
                "used": "2.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11930801,
                "dateCreated": "2021-12-10T21:52:12-06:00",
                "used": "-2.50",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11953612,
                "dateCreated": "2021-12-10T22:02:00-06:00",
                "used": "10.28",
                "total": "11.75"
            },
            {
                "idVoucher": "1dd6e30c34",
                "idOrder": 11953612,
                "dateCreated": "2021-12-10T22:02:00-06:00",
                "used": "-10.28",
                "total": "11.75"
            }
        ],
        "history": [
            {
                "idVoucher": "1dd6e30c34",
                "systemComments": "Created voucher with 150 starting balance. Created voucher with 150 starting balance. Created voucher with 150 starting balance. ",
                "comments": "",
                "dateCreated": "2020-12-04T22:02:25-06:00"
            }
        ]
    }
};